module.exports = __webpack_public_path__ + "img/fire_en.b095955d.svg";